/**
 * Checks whether the provided input is an array or not, serving as a type guard.
 * @param input unknown
 * @returns boolean
 */
export const isArrayUtil = (input) => Array.isArray(input);
export default isArrayUtil;
